import React, { Component } from "react";
import { connect } from "react-redux";

import { setCategoryMenuState } from "../actions/siteActions";

class CategoryButton extends Component {
  setCategoryMenuState = () => {
    const { site } = this.props;
    this.props.setCategoryMenuState(!site.categorymenu.open);
  };
  render() {
    const { site } = this.props;
    return (
      <button className="categoryButton" onClick={() => this.setCategoryMenuState()}>
        <img src={process.env.PUBLIC_URL + "/img/categorymenu.png"} alt="categories menu" />
        {/*!site.menu.open ? (
          <img src={process.env.PUBLIC_URL + "/img/menu.png"} alt="menu" />
        ) : (
          <img src={process.env.PUBLIC_URL + "/img/menu_close.png"} alt="menu" />
        )*/}
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, { setCategoryMenuState })(CategoryButton);
